/* Project Import will be here */
import { post, IRequest } from "../index";
/* Project Import will be here */

/* Get Kpi dashboard related information */
export const getKpiDashboardApi = () => {
  const request: IRequest = {
    subUrl: `/KPI/Monthly`
  };

  return post(request);
};